import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconWarningSignFilledSmall = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="m17.9 2.965 13.803 23.88c.84 1.48-.2 3.3-1.9 3.3H2.197c-1.7 0-2.74-1.82-1.9-3.3L14.1 2.965c.84-1.48 2.96-1.48 3.8 0m-3.233 8.202a1.333 1.333 0 0 1 2.666 0v8a1.333 1.333 0 0 1-2.666 0zm1.335 14.858a1.733 1.733 0 1 0 0-3.467 1.733 1.733 0 0 0 0 3.467" clipRule="evenodd" /></svg>;
export default SvgIconWarningSignFilledSmall;